module.exports = __webpack_public_path__ + "img/feishu.de7bc782.svg";